import { useMemo } from "react";
import { WatchForm } from "./WatchForm";

/** Standalone page wrapper for the alert subscription form. */
export function DnsAlerts() {
  // Prefill from the query string so "watch this" links from a lookup carry
  // the record across.
  const initial = useMemo(() => {
    const p = new URLSearchParams(window.location.search);
    return { host: p.get("host") ?? "", type: (p.get("type") ?? "A").toUpperCase() };
  }, []);

  return (
    <main className="console">
      <div className="input-row">
        <span className="input-row-label">ALERTS</span>
        <span className="gen-intro">
          Watch a DNS record and get an email the moment its value changes. Checked hourly.
        </span>
      </div>

      <div className="body-grid body-grid-single">
        <WatchForm initialHost={initial.host} initialType={initial.type} />
      </div>
    </main>
  );
}
